import React from 'react';
import './choiceEstablishment.css';
import { useDispatch, useSelector } from "react-redux";
import { currentEstablishmentAction, dropdownAction, firstCurrentVisitorsRequestAction } from "../../redux/rootReducer";
import { setLocalStorage } from "../../helpers/LocalStorage";

const ChoiceEstablishment = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const dropdown = useSelector(state => state.dropdown);

    return (
        <div className="dropdown choice_establishment">
            <div className={ `input ${ establishmentList.length > 1 ? 'input--tick' : 'input--inactive' }` }
                onClick={ () => dispatch(dropdownAction('choice_est')) }
            >
                { establishmentList?.find(el => el.id === currentEstablishment)?.name }
            </div>
            <div className={ `dropdown__items dropdown__items--choice-est ${ dropdown === 'choice_est' ? 'dropdown__items--open' : '' }` }>
                {
                    establishmentList.length > 1
                    ?
                        establishmentList.map(elem => {
                            return (
                                <div
                                    className="dropdown__item" key={ elem.id }
                                    onClick={ () => {
                                        dispatch(firstCurrentVisitorsRequestAction(false));
                                        setLocalStorage('afp_est', elem.id).then();
                                        dispatch(currentEstablishmentAction(elem.id));
                                        dispatch(dropdownAction(null));
                                    } }
                                >{ elem.name }</div>
                            )
                        })
                    : false
                }
            </div>
        </div>
    );
};

export default ChoiceEstablishment;